import type { FC, ReactNode } from 'react';
import clsx from 'clsx';
import { motion } from 'motion/react';

import { splitPaneAnimationProps } from '../constants';

import { splitPaneClasses } from './classes';
import { SplitSelector } from './SplitSelector';

interface SplitPaneContainerProps {
  children: ReactNode;
  fileName: string;
  width: number;
}

export const SplitPaneContainer: FC<SplitPaneContainerProps> = ({ children, fileName, width }) => {
  return (
    <motion.div {...splitPaneAnimationProps} className={clsx(splitPaneClasses)} style={{ width }}>
      <div className="flex items-center text-gray-500">
        <SplitSelector currentFileName={fileName} />
      </div>
      {children}
    </motion.div>
  );
};
